import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\PasswordResetLinkController::request
 * @see app/Http/Controllers/PasswordResetLinkController.php:60
 * @route '/login/help/password'
 */
export const request = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: request.url(options),
    method: 'get',
})

request.definition = {
    methods: ["get","head"],
    url: '/login/help/password',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PasswordResetLinkController::request
 * @see app/Http/Controllers/PasswordResetLinkController.php:60
 * @route '/login/help/password'
 */
request.url = (options?: RouteQueryOptions) => {
    return request.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasswordResetLinkController::request
 * @see app/Http/Controllers/PasswordResetLinkController.php:60
 * @route '/login/help/password'
 */
request.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: request.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PasswordResetLinkController::request
 * @see app/Http/Controllers/PasswordResetLinkController.php:60
 * @route '/login/help/password'
 */
request.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: request.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PasswordResetLinkController::request
 * @see app/Http/Controllers/PasswordResetLinkController.php:60
 * @route '/login/help/password'
 */
    const requestForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: request.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PasswordResetLinkController::request
 * @see app/Http/Controllers/PasswordResetLinkController.php:60
 * @route '/login/help/password'
 */
        requestForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: request.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PasswordResetLinkController::request
 * @see app/Http/Controllers/PasswordResetLinkController.php:60
 * @route '/login/help/password'
 */
        requestForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: request.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    request.form = requestForm
/**
* @see \App\Http\Controllers\PasswordResetLinkController::email
 * @see app/Http/Controllers/PasswordResetLinkController.php:68
 * @route '/login/help/password'
 */
export const email = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: email.url(options),
    method: 'post',
})

email.definition = {
    methods: ["post"],
    url: '/login/help/password',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PasswordResetLinkController::email
 * @see app/Http/Controllers/PasswordResetLinkController.php:68
 * @route '/login/help/password'
 */
email.url = (options?: RouteQueryOptions) => {
    return email.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasswordResetLinkController::email
 * @see app/Http/Controllers/PasswordResetLinkController.php:68
 * @route '/login/help/password'
 */
email.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: email.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\PasswordResetLinkController::email
 * @see app/Http/Controllers/PasswordResetLinkController.php:68
 * @route '/login/help/password'
 */
    const emailForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: email.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PasswordResetLinkController::email
 * @see app/Http/Controllers/PasswordResetLinkController.php:68
 * @route '/login/help/password'
 */
        emailForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: email.url(options),
            method: 'post',
        })
    
    email.form = emailForm
/**
* @see \App\Http\Controllers\PasswordResetController::reset
 * @see app/Http/Controllers/PasswordResetController.php:75
 * @route '/login/help/password/reset/{token}'
 */
export const reset = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reset.url(args, options),
    method: 'get',
})

reset.definition = {
    methods: ["get","head"],
    url: '/login/help/password/reset/{token}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PasswordResetController::reset
 * @see app/Http/Controllers/PasswordResetController.php:75
 * @route '/login/help/password/reset/{token}'
 */
reset.url = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { token: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    token: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        token: args.token,
                }

    return reset.definition.url
            .replace('{token}', parsedArgs.token.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasswordResetController::reset
 * @see app/Http/Controllers/PasswordResetController.php:75
 * @route '/login/help/password/reset/{token}'
 */
reset.get = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reset.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PasswordResetController::reset
 * @see app/Http/Controllers/PasswordResetController.php:75
 * @route '/login/help/password/reset/{token}'
 */
reset.head = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reset.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PasswordResetController::reset
 * @see app/Http/Controllers/PasswordResetController.php:75
 * @route '/login/help/password/reset/{token}'
 */
    const resetForm = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: reset.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PasswordResetController::reset
 * @see app/Http/Controllers/PasswordResetController.php:75
 * @route '/login/help/password/reset/{token}'
 */
        resetForm.get = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reset.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PasswordResetController::reset
 * @see app/Http/Controllers/PasswordResetController.php:75
 * @route '/login/help/password/reset/{token}'
 */
        resetForm.head = (args: { token: string | number } | [token: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: reset.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    reset.form = resetForm
/**
* @see \App\Http\Controllers\PasswordResetController::store
 * @see app/Http/Controllers/PasswordResetController.php:80
 * @route '/login/help/password/reset'
 */
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/login/help/password/reset',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PasswordResetController::store
 * @see app/Http/Controllers/PasswordResetController.php:80
 * @route '/login/help/password/reset'
 */
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasswordResetController::store
 * @see app/Http/Controllers/PasswordResetController.php:80
 * @route '/login/help/password/reset'
 */
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\PasswordResetController::store
 * @see app/Http/Controllers/PasswordResetController.php:80
 * @route '/login/help/password/reset'
 */
    const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: store.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PasswordResetController::store
 * @see app/Http/Controllers/PasswordResetController.php:80
 * @route '/login/help/password/reset'
 */
        storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: store.url(options),
            method: 'post',
        })
    
    store.form = storeForm
const password = {
    request: Object.assign(request, request),
email: Object.assign(email, email),
reset: Object.assign(reset, reset),
store: Object.assign(store, store),
}

export default password